export const getUserMutationKey = () => [`planner_user`];

export const getUserCredentialsMutationKey = () => [`planner_user_credentials`];

export const getUserAvatarMutationKey = () => [`planner_user_avatar`];
